import React, { useContext } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import CartItemPriceDisplay from '@components/cart/CartItemPriceDisplay';
import { Context } from '@components/Context';
import CreditsIcon from '@icons/credits.svg';
import { getPriceText } from '@utils/price';
import { useOrderTotals } from '../../hooks/useOrderTotals';
import CartItemRow from './CartItemRow';

const CreditCartItemRow: React.FC = () => {
  const { t } = useTranslation();
  const { state } = useContext(Context);
  const { currency, country } = state;
  const { appliedCredit } = useOrderTotals();

  // Only show the credit row if the applied credit is greater than zero.
  if (appliedCredit <= 0) {
    return null;
  }

  const priceText = `-${getPriceText(appliedCredit, country, currency, t).fullString}`;

  return (
    <CartItemRow
      imageComponent={<CreditsIcon />}
      titleComponent={t('components.credits')}
      priceComponent={<CartItemPriceDisplay price={priceText} />}
      className="credit-price"
    />
  );
};

export default CreditCartItemRow;
